import { render, staticRenderFns } from "./BarChartForPoint.vue?vue&type=template&id=2a4d027b"
import script from "./BarChartForPoint.vue?vue&type=script&lang=js"
export * from "./BarChartForPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports